import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import swal from 'sweetalert';

import {withStyles} from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import blue from '@material-ui/core/colors/blue';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

class JournalIndexButton extends React.Component {
    static propTypes = {
        href: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        title: PropTypes.string,
    };

    static defaultProps = {
        title: '',
    };

    showModal(event) {
        event.stopPropagation();
    };

    render() {
        const {classes} = this.props;
        return (
            <IconButton
                component="a"
                //href = {this.props.href}
                {...this.props}
            >
                <Icon>{this.props.icon}</Icon>
            </IconButton>
        );
    }
}

const styles = theme => ({

});

export default withStyles(styles)(JournalIndexButton);
